module.exports = __webpack_public_path__ + "static/media/PDF_76.9d4f081e.pdf";